module.exports = __webpack_public_path__ + "img/home-image1.b25e495b.png";